module.exports = __webpack_public_path__ + "static/ricky-halloween-fa55e9e960267a0a148b5008fdcf6f8d.png";